import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import { AccountingPostingPositionModuleList } from "src/admin/modules/accounting-posting-position/components/AccountingPostingPositionModuleList/AccountingPostingPositionModuleList.tsx";
import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";

const paths = createModuleRoutePaths({
  resource: ResourceEnum.AccountingPostingPosition,
});
export const module: ModuleOptions = {
  resource: ResourceEnum.AccountingPostingPosition,
  smallIcon: <i className="icon-15-account" />,
  bigIcon: <i className="icon-20-account" />,
  routeObjects: [
    {
      path: paths.root,
      Component: AccountingPostingPositionModuleList,
    },
  ],
  disableEdit: true,
  disableDelete: true,
  disableCreate: true,
};
